export default {
  container: {
    textAlign: 'center'
  },
  logo: {
    width: 200,
  }
}



// WEBPACK FOOTER //
// ./src/components/loope-logo/LoopeLogo.styles.js